module.exports = __webpack_public_path__ + "img/logo.01f71df8.svg";